import PropTypes from 'prop-types';
export const detailsPropTypes = {
  label: PropTypes.string,
  richtext: PropTypes.string
};